(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-sticky-product-bar"] && !Shopify.designMode) return;
  try {
    
  class BlogStickyBar extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('[data-bspb-variants]');
      if (!dataEl) return;

      try {
        this.variants = JSON.parse(dataEl.textContent);
      } catch (error) {
        console.error('Blog sticky bar: could not read variant data', error);
        return;
      }
      if (!Array.isArray(this.variants) || !this.variants.length) return;

      this.optionCount = parseInt(this.dataset.optionCount, 10) || 1;
      this.panel = this.querySelector('[data-bspb-panel]');
      this.form = this.querySelector('form');
      this.submit = this.querySelector('[data-bspb-submit]');
      this.btnLabels = Array.from(this.querySelectorAll('[data-bspb-label]'));
      this.idInput = this.querySelector('[data-bspb-variant-id]');
      this.compareEl = this.querySelector('[data-bspb-compare]');
      this.nowEl = this.querySelector('[data-bspb-now]');
      this.imgEl = this.querySelector('[data-bspb-image]');
      this.chips = Array.from(this.querySelectorAll('[data-bspb-value]'));

      // Sold-out products render a link to the product page instead of a form.
      if (!this.submit) {
        this.bindScroll();
        return;
      }

      // Resting state is the product itself. Remembered so clearing a choice
      // restores it instead of drifting to whichever variant came first.
      this.base = {
        price: this.nowEl ? this.nowEl.textContent : '',
        compare: this.compareEl ? this.compareEl.textContent : '',
        compareHidden: this.compareEl ? this.compareEl.hidden : true,
        image: this.imgEl ? this.imgEl.getAttribute('src') : null,
        srcset: this.imgEl ? this.imgEl.getAttribute('srcset') : null,
      };

      this.selected = new Array(this.optionCount).fill(null);
      this.isOpen = false;

      this.handleChipClick = this.handleChipClick.bind(this);
      this.handleChipKeydown = this.handleChipKeydown.bind(this);
      this.handleSubmitClick = this.handleSubmitClick.bind(this);
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handlePointerDown = this.handlePointerDown.bind(this);

      this.chips.forEach((chip) => {
        chip.addEventListener('click', this.handleChipClick);
        chip.addEventListener('keydown', this.handleChipKeydown);
        // An option with a single value has nothing to choose; every other
        // option starts unselected.
        if (chip.hasAttribute('data-bspb-only-value')) {
          this.selected[Number(chip.dataset.optionIndex)] = chip.value;
        }
      });
      this.submit.addEventListener('click', this.handleSubmitClick);
      if (this.form) this.form.addEventListener('submit', this.handleFormSubmit);

      const closeBtn = this.querySelector('[data-bspb-close]');
      if (closeBtn) closeBtn.addEventListener('click', () => this.setOpen(false));

      document.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('pointerdown', this.handlePointerDown);

      // A product with a single variant has nothing to pick, so the bar keeps
      // its one-tap behaviour.
      if (!this.panel) this.idInput.value = (this.variants.find((v) => v.available) || this.variants[0]).id;

      this.refresh();
      this.bindScroll();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('pointerdown', this.handlePointerDown);
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.sync) {
        window.removeEventListener('resize', this.sync);
        if (window.visualViewport) {
          window.visualViewport.removeEventListener('resize', this.sync);
          window.visualViewport.removeEventListener('scroll', this.sync);
        }
      }
      if (this.sizeObserver) this.sizeObserver.disconnect();
      if (this.domObserver) this.domObserver.disconnect();
    }

    bindScroll() {
      const threshold = parseInt(this.dataset.scrollThreshold, 10) || 400;
      let ticking = false;

      // The bar has to sit at the bottom of what the visitor can SEE, and two
      // things on this store break a plain `position: fixed; bottom: 0`:
      //  - the article's product gallery overflows the screen horizontally,
      //    and mobile browsers then lay fixed elements out against a layout
      //    viewport that is wider (and taller) than the screen, so the bar
      //    ends up narrower than the screen, or partly below it;
      //  - Shopify's theme-preview bar covers the bottom of the page while
      //    the merchant reviews a draft, hiding whatever sits under it.
      // So the bar is pinned to the visual viewport and lifted above the
      // preview bar when one exists. A live page that fits its screen
      // resolves to the ordinary bottom-left corner.
      this.sync = () => {
        const vv = window.visualViewport;
        const previewBar = this.previewBar();
        const lift = previewBar ? Math.round(previewBar.getBoundingClientRect().height) : 0;

        // Pinch-zoomed in, or a visual viewport that does not even agree with
        // the document's own width (some headless/embedded browsers report a
        // stale one): leave the browser's native fixed behaviour alone rather
        // than chase numbers that cannot be trusted.
        const untrusted = !vv || vv.scale > 1.01 || Math.abs(vv.width - document.documentElement.clientWidth) > 2;
        if (untrusted) {
          this.style.width = document.documentElement.clientWidth + 'px';
          this.style.left = '';
          this.style.top = '';
          this.style.bottom = lift + 'px';
          return;
        }

        this.style.width = Math.round(vv.width) + 'px';
        this.style.left = Math.round(vv.offsetLeft) + 'px';
        if (Math.round(vv.height) < window.innerHeight - 1) {
          // Layout viewport taller than the screen: anchor to the visible bottom.
          this.style.top = Math.round(vv.offsetTop + vv.height - lift - this.offsetHeight) + 'px';
          this.style.bottom = 'auto';
        } else {
          this.style.top = '';
          this.style.bottom = lift + 'px';
        }
      };

      const update = () => {
        // Never pull the bar out from under an open picker.
        this.classList.toggle('bspb--visible', this.isOpen || window.scrollY > threshold);
        this.sync();
        ticking = false;
      };

      this.onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };

      window.addEventListener('resize', this.sync, { passive: true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', this.sync, { passive: true });
        window.visualViewport.addEventListener('scroll', this.sync, { passive: true });
      }
      window.addEventListener('scroll', this.onScroll, { passive: true });

      if ('ResizeObserver' in window) {
        // Re-anchor when the bar's own height changes (picker opens/closes)
        // and when the preview bar appears or changes size — Shopify injects
        // it after the page has loaded.
        this.sizeObserver = new ResizeObserver(() => this.sync());
        this.sizeObserver.observe(this);
        const watchPreviewBar = () => {
          const previewBar = this.previewBar();
          if (!previewBar) return false;
          this.sizeObserver.observe(previewBar);
          return true;
        };
        if (!watchPreviewBar() && 'MutationObserver' in window) {
          this.domObserver = new MutationObserver(() => {
            if (watchPreviewBar()) this.domObserver.disconnect();
          });
          this.domObserver.observe(document.body, { childList: true });
        }
      }

      this.sync();
      this.onScroll();
    }

    /**
     * Shopify's theme-preview bar: the current one wraps its iframe in
     * #PBarNextFrameWrapper; older storefronts still get #preview-bar-iframe.
     * Absent on the live theme.
     */
    previewBar() {
      return document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
    }

    /** Does this variant agree with every choice made before option `upto`? */
    matchesPrefix(variant, upto) {
      for (let i = 0; i < upto; i += 1) {
        if (this.selected[i] !== null && variant.options[i] !== this.selected[i]) return false;
      }
      return true;
    }

    variantFor() {
      if (this.selected.some((value) => value === null)) return null;
      return this.variants.find((v) => this.selected.every((value, i) => v.options[i] === value)) || null;
    }

    choose(chip) {
      const index = Number(chip.dataset.optionIndex);
      if (chip.disabled || this.selected[index] === chip.value) return;
      this.selected[index] = chip.value;

      // Clear the choices that come after this one. Women's 5 and Men's 5 are
      // not the same shoe, so switching Gender must not silently keep a size
      // that only exists for the other one — without this the shopper hits a
      // dead end where every remaining size is disabled.
      for (let i = index + 1; i < this.optionCount; i += 1) {
        const only = this.chips.find((c) => Number(c.dataset.optionIndex) === i && c.hasAttribute('data-bspb-only-value'));
        this.selected[i] = only ? only.value : null;
      }

      this.refresh();
    }

    handleChipClick(event) {
      this.choose(event.currentTarget);
    }

    /** Arrow keys move within a group, matching native radio behaviour. */
    handleChipKeydown(event) {
      const keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
      if (!keys.includes(event.key)) return;
      const chip = event.currentTarget;
      const group = this.chips.filter((c) => c.dataset.optionIndex === chip.dataset.optionIndex && !c.disabled);
      if (group.length < 2) return;
      event.preventDefault();
      const step = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
      const next = group[(group.indexOf(chip) + step + group.length) % group.length];
      next.focus({ preventScroll: true });
      this.choose(next);
    }

    refresh() {
      // Grey out values that cannot lead to a purchasable variant given the
      // choices already made to their left, and reflect the current choice.
      this.chips.forEach((chip) => {
        const index = Number(chip.dataset.optionIndex);
        chip.disabled = !this.variants.some(
          (v) => v.available && v.options[index] === chip.value && this.matchesPrefix(v, index),
        );
        const checked = this.selected[index] === chip.value;
        chip.setAttribute('aria-checked', String(checked));
        chip.tabIndex = checked || (this.selected[index] === null && !chip.disabled) ? 0 : -1;
      });

      const variant = this.variantFor();
      this.updatePrice(variant);
      this.updateImage();

      if (this.panel) {
        this.idInput.value = variant && variant.available ? variant.id : '';
      }

      this.updateButton(variant);
    }

    updateButton(variant) {
      // A product with a single variant has no picker: connectedCallback has
      // already put that variant in the hidden input, so the button is a plain
      // Add to Cart. It ships disabled so a page without JS cannot post an
      // empty variant id — enable it once a variant has actually been resolved.
      if (!this.panel) {
        this.submit.disabled = !this.idInput.value;
        return;
      }

      let label = 'add';
      let disabled = false;

      if (this.isOpen) {
        if (!variant) {
          label = 'select';
          disabled = true;
        } else if (!variant.available) {
          label = 'sold_out';
          disabled = true;
        }
      }

      this.btnLabels.forEach((el) => el.classList.toggle('bspb__btn-label--active', el.dataset.bspbLabel === label));
      this.submit.disabled = disabled;
    }

    /** Price follows the choice; with nothing chosen it stays the product's. */
    updatePrice(variant) {
      if (!this.nowEl) return;
      const anyChosen = this.selected.some((value) => value !== null);
      const shown = variant || (anyChosen
        ? this.variants.find((v) => v.available && this.matchesPrefix(v, this.optionCount))
        : null);

      if (!shown) {
        this.nowEl.textContent = this.base.price;
        if (this.compareEl) {
          this.compareEl.textContent = this.base.compare;
          this.compareEl.hidden = this.base.compareHidden;
        }
        return;
      }

      this.nowEl.textContent = shown.price;
      if (this.compareEl) {
        this.compareEl.textContent = shown.compareAtPrice || '';
        this.compareEl.hidden = !shown.compareAtPrice;
      }
    }

    /** Photo follows the colour once one is chosen; otherwise the product's. */
    updateImage() {
      if (!this.imgEl) return;
      const anyChosen = this.selected.some((value) => value !== null);
      const shown = anyChosen
        ? this.variants.find((v) => v.image && this.matchesPrefix(v, this.optionCount))
        : null;

      const src = shown ? shown.image : this.base.image;
      const srcset = shown ? shown.image + ' 1x, ' + (shown.image2x || shown.image) + ' 2x' : this.base.srcset;
      if (!src || this.imgEl.getAttribute('src') === src) return;

      this.imgEl.setAttribute('srcset', srcset || '');
      this.imgEl.setAttribute('src', src);
    }

    setOpen(open, viaKeyboard) {
      if (!this.panel) return;
      this.isOpen = open;
      this.panel.hidden = !open;
      this.submit.setAttribute('aria-expanded', String(open));
      this.refresh();
      // The bar's height just changed; keep its bottom edge on the visible bottom.
      if (this.sync) this.sync();

      if (open) {
        this.classList.add('bspb--visible');
        // Only move focus for keyboard users: a programmatic focus on touch
        // makes some browsers scroll the page, which reads as a jump.
        if (viaKeyboard) {
          const first = this.chips.find((chip) => chip.tabIndex === 0);
          if (first) first.focus({ preventScroll: true });
        }
      } else if (this.onScroll) {
        this.onScroll();
      }
    }

    handleSubmitClick(event) {
      // First tap opens the picker rather than adding anything; once a full
      // variant is chosen the button is a normal submit and falls through.
      if (this.panel && !this.isOpen) {
        event.preventDefault();
        this.setOpen(true, event.detail === 0);
        return;
      }

      // Letting the submit through: fold the picker away so the bar is back to
      // its slim resting state behind the cart drawer. The chosen variant is
      // held in the hidden input, so the submit survives this.
      if (this.panel && this.idInput.value) this.setOpen(false);
    }

    handleFormSubmit(event) {
      if (this.panel && !this.idInput.value) event.preventDefault();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.isOpen) this.setOpen(false);
    }

    handlePointerDown(event) {
      if (this.isOpen && !this.contains(event.target)) this.setOpen(false);
    }
  }

  if (!customElements.get('blog-sticky-bar')) {
    customElements.define('blog-sticky-bar', BlogStickyBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  // Makes a whole brand row navigate, on top of the real links Liquid put in
  // its first cell. Plain left clicks only: modified clicks, text selection and
  // clicks on links or controls inside the row keep their native behaviour.
  class ArticleBrandRows extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (event.target.closest('a, button, input, select, textarea, label')) return;

      const row = event.target.closest('tr[data-brand-row]');
      if (!row || !this.contains(row)) return;

      const selection = window.getSelection();
      if (selection && selection.toString()) return;

      const url = row.getAttribute('data-brand-row');
      if (url) window.location.assign(url);
    }
  }

  if (!customElements.get('article-brand-rows')) {
    customElements.define('article-brand-rows', ArticleBrandRows);
  }

  /**
   * Inline product card: the same picker logic as the blog sticky bar
   * (sections/blog-sticky-product-bar.liquid), without the fixed positioning.
   * Nothing is pre-selected; the button opens the picker first and can only
   * submit once every option resolves to a real, purchasable variant.
   */
  class BlogInlineCard extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('[data-bipc-variants]');
      if (!dataEl) return;

      try {
        this.variants = JSON.parse(dataEl.textContent);
      } catch (error) {
        console.error('Inline product card: could not read variant data', error);
        return;
      }
      if (!Array.isArray(this.variants) || !this.variants.length) return;

      this.optionCount = parseInt(this.dataset.optionCount, 10) || 1;
      this.panel = this.querySelector('[data-bipc-panel]');
      this.form = this.querySelector('form');
      this.submit = this.querySelector('[data-bipc-submit]');
      this.btnLabels = Array.from(this.querySelectorAll('[data-bipc-label]'));
      this.idInput = this.querySelector('[data-bipc-variant-id]');
      this.compareEl = this.querySelector('[data-bipc-compare]');
      this.nowEl = this.querySelector('[data-bipc-now]');
      this.imgEl = this.querySelector('[data-bipc-image]');
      this.chips = Array.from(this.querySelectorAll('[data-bipc-value]'));

      // Photos the product page shows per option value (see the Liquid above).
      // Optional: a gallery without tags simply leaves this empty.
      this.optionImages = [];
      const optionImagesEl = this.querySelector('[data-bipc-option-images]');
      if (optionImagesEl) {
        try {
          this.optionImages = JSON.parse(optionImagesEl.textContent).filter(Boolean);
        } catch (error) {
          this.optionImages = [];
        }
      }

      // Sold-out products render a link to the product page instead of a form.
      if (!this.submit) return;

      // Resting state is the product itself. Remembered so clearing a choice
      // restores it instead of drifting to whichever variant came first.
      this.base = {
        price: this.nowEl ? this.nowEl.textContent : '',
        compare: this.compareEl ? this.compareEl.textContent : '',
        compareHidden: this.compareEl ? this.compareEl.hidden : true,
        image: this.imgEl ? this.imgEl.getAttribute('src') : null,
        srcset: this.imgEl ? this.imgEl.getAttribute('srcset') : null,
      };

      this.selected = new Array(this.optionCount).fill(null);
      this.isOpen = false;

      this.handleChipClick = this.handleChipClick.bind(this);
      this.handleChipKeydown = this.handleChipKeydown.bind(this);
      this.handleSubmitClick = this.handleSubmitClick.bind(this);
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);

      this.chips.forEach((chip) => {
        chip.addEventListener('click', this.handleChipClick);
        chip.addEventListener('keydown', this.handleChipKeydown);
        // An option with a single value has nothing to choose; every other
        // option starts unselected.
        if (chip.hasAttribute('data-bipc-only-value')) {
          this.selected[Number(chip.dataset.optionIndex)] = chip.value;
        }
      });
      this.submit.addEventListener('click', this.handleSubmitClick);
      if (this.form) this.form.addEventListener('submit', this.handleFormSubmit);

      const closeBtn = this.querySelector('[data-bipc-close]');
      if (closeBtn) closeBtn.addEventListener('click', () => this.setOpen(false));
      this.addEventListener('keydown', this.handleKeydown);

      // A product with a single variant has nothing to pick: one-tap add.
      if (!this.panel) this.idInput.value = (this.variants.find((v) => v.available) || this.variants[0]).id;

      this.refresh();
    }

    /** Does this variant agree with every choice made before option `upto`? */
    matchesPrefix(variant, upto) {
      for (let i = 0; i < upto; i += 1) {
        if (this.selected[i] !== null && variant.options[i] !== this.selected[i]) return false;
      }
      return true;
    }

    variantFor() {
      if (this.selected.some((value) => value === null)) return null;
      return this.variants.find((v) => this.selected.every((value, i) => v.options[i] === value)) || null;
    }

    choose(chip) {
      const index = Number(chip.dataset.optionIndex);
      if (chip.disabled || this.selected[index] === chip.value) return;
      this.selected[index] = chip.value;

      // Clear the choices that come after this one: Women's 5 and Men's 5 are
      // not the same shoe, so switching Gender must not silently keep a size
      // that only exists for the other one.
      for (let i = index + 1; i < this.optionCount; i += 1) {
        const only = this.chips.find((c) => Number(c.dataset.optionIndex) === i && c.hasAttribute('data-bipc-only-value'));
        this.selected[i] = only ? only.value : null;
      }

      this.refresh();
    }

    handleChipClick(event) {
      this.choose(event.currentTarget);
    }

    /** Arrow keys move within a group, matching native radio behaviour. */
    handleChipKeydown(event) {
      const keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
      if (!keys.includes(event.key)) return;
      const chip = event.currentTarget;
      const group = this.chips.filter((c) => c.dataset.optionIndex === chip.dataset.optionIndex && !c.disabled);
      if (group.length < 2) return;
      event.preventDefault();
      const step = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
      const next = group[(group.indexOf(chip) + step + group.length) % group.length];
      next.focus({ preventScroll: true });
      this.choose(next);
    }

    refresh() {
      // Grey out values that cannot lead to a purchasable variant given the
      // choices already made to their left, and reflect the current choice.
      this.chips.forEach((chip) => {
        const index = Number(chip.dataset.optionIndex);
        chip.disabled = !this.variants.some(
          (v) => v.available && v.options[index] === chip.value && this.matchesPrefix(v, index),
        );
        const checked = this.selected[index] === chip.value;
        chip.setAttribute('aria-checked', String(checked));
        chip.tabIndex = checked || (this.selected[index] === null && !chip.disabled) ? 0 : -1;
      });

      const variant = this.variantFor();
      this.updatePrice(variant);
      this.updateImage();

      if (this.panel) {
        this.idInput.value = variant && variant.available ? variant.id : '';
      }

      this.updateButton(variant);
    }

    updateButton(variant) {
      // Single-variant product: connectedCallback already put that variant in
      // the hidden input. Shipped disabled so a page without JS cannot post an
      // empty id — enabled here once a variant has actually been resolved.
      if (!this.panel) {
        this.submit.disabled = !this.idInput.value;
        return;
      }

      let label = 'add';
      let disabled = false;

      if (this.isOpen) {
        if (!variant) {
          label = 'select';
          disabled = true;
        } else if (!variant.available) {
          label = 'sold_out';
          disabled = true;
        }
      }

      this.btnLabels.forEach((el) => el.classList.toggle('bipc__btn-label--active', el.dataset.bipcLabel === label));
      this.submit.disabled = disabled;
    }

    /** Price follows the choice; with nothing chosen it stays the product's. */
    updatePrice(variant) {
      if (!this.nowEl) return;
      const anyChosen = this.selected.some((value) => value !== null);
      const shown = variant || (anyChosen
        ? this.variants.find((v) => v.available && this.matchesPrefix(v, this.optionCount))
        : null);

      if (!shown) {
        this.nowEl.textContent = this.base.price;
        if (this.compareEl) {
          this.compareEl.textContent = this.base.compare;
          this.compareEl.hidden = this.base.compareHidden;
        }
        return;
      }

      this.nowEl.textContent = shown.price;
      if (this.compareEl) {
        this.compareEl.textContent = shown.compareAtPrice || '';
        this.compareEl.hidden = !shown.compareAtPrice;
      }
    }

    /**
     * Photo follows the colour once one is chosen; otherwise the product's.
     * The product page's own photo for that colour comes first, the variant's
     * photo is the fallback for a gallery that tags nothing.
     */
    updateImage() {
      if (!this.imgEl) return;
      const anyChosen = this.selected.some((value) => value !== null);
      const tagged = anyChosen
        ? this.optionImages.find(
            (entry) => this.selected[entry.index] !== null && String(this.selected[entry.index]).toLowerCase() === entry.value,
          )
        : null;
      const shown = tagged || (anyChosen
        ? this.variants.find((v) => v.image && this.matchesPrefix(v, this.optionCount))
        : null);

      const src = shown ? shown.image : this.base.image;
      const srcset = shown ? shown.image + ' 1x, ' + (shown.image2x || shown.image) + ' 2x' : this.base.srcset;
      if (!src || this.imgEl.getAttribute('src') === src) return;

      this.imgEl.setAttribute('srcset', srcset || '');
      this.imgEl.setAttribute('src', src);
    }

    setOpen(open, viaKeyboard) {
      if (!this.panel) return;
      this.isOpen = open;
      this.panel.hidden = !open;
      this.submit.setAttribute('aria-expanded', String(open));
      this.refresh();

      // Only move focus for keyboard users: a programmatic focus on touch
      // makes some browsers scroll the page, which reads as a jump.
      if (open && viaKeyboard) {
        const first = this.chips.find((chip) => chip.tabIndex === 0);
        if (first) first.focus({ preventScroll: true });
      }
    }

    handleSubmitClick(event) {
      // First tap opens the picker rather than adding anything; once a full
      // variant is chosen the button is a normal submit and falls through.
      if (this.panel && !this.isOpen) {
        event.preventDefault();
        this.setOpen(true, event.detail === 0);
        return;
      }

      // Letting the submit through: fold the picker away so the card is back
      // to its resting state behind the cart drawer. The chosen variant is
      // held in the hidden input, so the submit survives this.
      if (this.panel && this.idInput.value) this.setOpen(false);
    }

    handleFormSubmit(event) {
      if (this.panel && !this.idInput.value) event.preventDefault();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.isOpen) this.setOpen(false);
    }
  }

  if (!customElements.get('blog-inline-card')) {
    customElements.define('blog-inline-card', BlogInlineCard);
  }

  } catch(e) { console.error(e); }
})();
})();
